import React from "react";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider, Button, TextField } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import { blue } from "@material-ui/core/colors";
import Translate from "../../common/functions/translate";
import Snackbar from "../../common/components/snackbar/snackbar";
import { ClientDataModel } from "../../models/offerSteps/clientDataModel";

interface IProps {
    isOpen: boolean;
    toggle: any;
    onChangeClient: any;
    selectedClient: ClientDataModel,
    onEditClientData: any;
}

interface IState {
    selectedClient: ClientDataModel,
    validations: Array<string>,
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important',
                minHeight: 300
            },
            paperFullWidth: {
                width: '40%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class EditClientDataDialog extends React.Component<IProps, IState> {
    snackbar: any;

    constructor(props) {
        super(props);

        this.state = {
            selectedClient: this.props.selectedClient,
            validations: new Array<string>(),
        }
    }

    componentDidMount() {

    }

    handleChange = (key, value) => {
        let selectedClient: ClientDataModel = { ...this.state.selectedClient };
        selectedClient[key] = value;
        this.setState({ selectedClient: { ...selectedClient } });
    }

    isValid = () => {
        let selectedClient = { ...this.state.selectedClient };
        let validations = new Array<string>(0);
        let error = "";

        if (!selectedClient.name) {
            validations.push("name");
            error += Translate("Please enter cleint name.") + " ";
        }

        this.setState({
            validations: validations
        });

        if (validations.length > 0) {
            this.snackbar.show({ severity: 'error', summary: error });
            return false;
        }

        return true;
    }

    handleSaveBtn = () => {
        if (!this.isValid()) {
            return;
        }

        let client = { ...this.state.selectedClient }
        this.props.onEditClientData(client);
    }

    render() {
        const { selectedClient } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isOpen}
                    onClose={() => this.props.toggle(false)}
                    fullWidth
                    disableBackdropClick={true}>
                    <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.props.toggle(false)}>{Translate('Edit client')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        <div>
                            <Snackbar ref={(el) => this.snackbar = el} />
                            <div style={{ marginBottom: 10 }}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <TextField
                                        name="name"
                                        label={Translate("Client name")}
                                        type="text"
                                        error={this.state.validations.includes("name")}
                                        onChange={(e) => this.handleChange('name', e.target['value'])}
                                        value={selectedClient.name || ''}
                                        style={{ width: 610, marginRight: 10 }}
                                    />
                                </div>

                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <TextField
                                    name="email"
                                    type="email"
                                    label={Translate("Email")}
                                    onChange={(e) => this.handleChange('email', e.target['value'])}
                                    value={selectedClient.email || ''}
                                    style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                                />

                                <TextField
                                    name="phone"
                                    type="text"
                                    label={Translate("Phone")}
                                    onChange={(e) => this.handleChange('phone', e.target['value'])}
                                    value={selectedClient.phone || ''}
                                    style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                                />
                            </div>
                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={() => this.props.toggle(false)} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button color="primary"
                                variant="contained"
                                onClick={this.handleSaveBtn}>
                                {Translate('Save')}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }
}

export default EditClientDataDialog